import { pluralCategory } from '@/i18n/format.ts'
import type { Messages } from '@/i18n/messages/en/index.ts'

/**
 * `admin.reports` in Brazilian Portuguese.
 *
 * A *report* here is a **denúncia** — feminine — which is why every status reads *Aberta*,
 * *Analisada*, *Descartada*. The five categories are a different noun: they classify the
 * behaviour being reported, not the report, so they agree masculine (*Nocivo ou inseguro*).
 * Two maps, two nouns, two agreements — and it is the sort of thing English gives no sign
 * of, so it is settled here once rather than guessed at per badge (PRD-27 D-21).
 *
 * *Triaged* becomes **Analisada** rather than a calque on *triagem*: the button and the
 * badge have to read as ordinary Brazilian product copy, and "triada" does not.
 */
export const reports: Messages['admin']['reports'] = {
  title: 'Agentes denunciados',
  lead: 'Denúncias de pessoas que usam a plataforma. Quem denunciou fica visível aqui e nunca para a pessoa responsável pelo agente. Volume sozinho nunca muda o estado de uma listagem.',
  loading: 'Carregando as denúncias…',
  unavailable: 'A fila de denúncias ainda não está disponível nesta instalação',
  unavailableBody: 'GET /api/admin/marketplace/reports não respondeu.',
  empty: 'Nada denunciado',
  emptyBody: 'As denúncias de quem usa a plataforma chegam aqui para triagem.',

  categories: {
    impersonation: 'Personificação',
    harmful: 'Nocivo ou inseguro',
    wrong: 'Impreciso',
    inappropriate: 'Inadequado',
    other: 'Outro'
  },

  statuses: {
    open: 'Aberta',
    triaged: 'Analisada',
    dismissed: 'Descartada'
  },

  reportedBy: (name) => `denúncia de ${name}`,
  repeatReporter: (fmt, count) =>
    pluralCategory(fmt.locale, count) === 'one'
      ? `${fmt.formatCount(count)} denúncia desta pessoa na fila`
      : `${fmt.formatCount(count)} denúncias desta pessoa na fila`,
  openConversation: 'Abrir a conversa denunciada',
  noConversation: 'Nenhuma conversa foi anexada.',
  openListing: 'Abrir a listagem',
  noteEmpty: 'Nenhuma nota foi escrita.',

  triage: 'Marcar como analisada',
  dismiss: 'Descartar',
  working: 'Registrando…',
  failed: 'Essa decisão não foi registrada.',
  filterLabel: 'Mostrar',
  filterOpen: 'Só as abertas',
  filterAll: 'Tudo'
}
